// Shared between src/sw.js and src/App.jsx (manual downloads write directly
// into the same Cache Storage bucket the service worker reads from).
export const AUDIO_CACHE = 'music-archive-audio-v1'
